"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listOfStates = void 0;
exports.listOfStates = {
    AU: [
        { isoCode: 'NSW', label: 'New South Wales' },
        { isoCode: 'VIC', label: 'Victoria' },
        { isoCode: 'QLD', label: 'Queensland' },
        { isoCode: 'TAS', label: 'Tasmania' },
        { isoCode: 'SA', label: 'South Australia' },
        { isoCode: 'WA', label: 'Western Australia' },
        { isoCode: 'NT', label: 'Northern Territory' },
        { isoCode: 'ACT', label: 'Australian Capital Territory' },
    ],
    CA: [
        { isoCode: 'AB', label: 'Alberta' },
        { isoCode: 'BC', label: 'British Columbia' },
        { isoCode: 'MB', label: 'Manitoba' },
        { isoCode: 'NB', label: 'New Brunswick' },
        { isoCode: 'NL', label: 'Newfoundland and Labrador' },
        { isoCode: 'NS', label: 'Nova Scotia' },
        { isoCode: 'NT', label: 'Northwest Territories' },
        { isoCode: 'NU', label: 'Nunavut' },
        { isoCode: 'ON', label: 'Ontario' },
        { isoCode: 'PE', label: 'Prince Edward Island' },
        { isoCode: 'QC', label: 'Québec' },
        { isoCode: 'SK', label: 'Saskatchewan' },
        { isoCode: 'YT', label: 'Yukon' },
    ],
    US: [
        { isoCode: 'AL', label: 'Alabama' },
        { isoCode: 'AK', label: 'Alaska' },
        { isoCode: 'AZ', label: 'Arizona' },
        { isoCode: 'AR', label: 'Arkansas' },
        { isoCode: 'CA', label: 'California' },
        { isoCode: 'CO', label: 'Colorado' },
        { isoCode: 'CT', label: 'Connecticut' },
        { isoCode: 'DE', label: 'Delaware' },
        { isoCode: 'DC', label: 'District Of Columbia' },
        { isoCode: 'FL', label: 'Florida' },
        { isoCode: 'GA', label: 'Georgia' },
        { isoCode: 'HI', label: 'Hawaii' },
        { isoCode: 'ID', label: 'Idaho' },
        { isoCode: 'IL', label: 'Illinois' },
        { isoCode: 'IN', label: 'Indiana' },
        { isoCode: 'IA', label: 'Iowa' },
        { isoCode: 'KS', label: 'Kansas' },
        { isoCode: 'KY', label: 'Kentucky' },
        { isoCode: 'LA', label: 'Louisiana' },
        { isoCode: 'ME', label: 'Maine' },
        { isoCode: 'MD', label: 'Maryland' },
        { isoCode: 'MA', label: 'Massachusetts' },
        { isoCode: 'MI', label: 'Michigan' },
        { isoCode: 'MN', label: 'Minnesota' },
        { isoCode: 'MS', label: 'Mississippi' },
        { isoCode: 'MO', label: 'Missouri' },
        { isoCode: 'MT', label: 'Montana' },
        { isoCode: 'NE', label: 'Nebraska' },
        { isoCode: 'NV', label: 'Nevada' },
        { isoCode: 'NH', label: 'New Hampshire' },
        { isoCode: 'NJ', label: 'New Jersey' },
        { isoCode: 'NM', label: 'New Mexico' },
        { isoCode: 'NY', label: 'New York' },
        { isoCode: 'NC', label: 'North Carolina' },
        { isoCode: 'ND', label: 'North Dakota' },
        { isoCode: 'OH', label: 'Ohio' },
        { isoCode: 'OK', label: 'Oklahoma' },
        { isoCode: 'OR', label: 'Oregon' },
        { isoCode: 'PA', label: 'Pennsylvania' },
        { isoCode: 'PR', label: 'Puerto Rico' },
        { isoCode: 'RI', label: 'Rhode Island' },
        { isoCode: 'SC', label: 'South Carolina' },
        { isoCode: 'SD', label: 'South Dakota' },
        { isoCode: 'TN', label: 'Tennessee' },
        { isoCode: 'TX', label: 'Texas' },
        { isoCode: 'UT', label: 'Utah' },
        { isoCode: 'VT', label: 'Vermont' },
        { isoCode: 'VA', label: 'Virginia' },
        { isoCode: 'WA', label: 'Washington' },
        { isoCode: 'WV', label: 'West Virginia' },
        { isoCode: 'WI', label: 'Wisconsin' },
        { isoCode: 'WY', label: 'Wyoming' },
    ],
};
//# sourceMappingURL=ListOfStates.js.map